import React, { useState } from 'react';
import { Check, X, Terminal } from 'lucide-react';
import './MainMatm.css'
import { BASE_URL_APISERVICES } from '../../../utils/Constants';
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';




const bankList = [
    "AXIS BANK",
    "BANK OF BARODA",
    "CANARA BANK",
    "ICICI BANK",
    "IDBI BANK",
    "KOTAK BANK",
    "PUNJAB NATIONAL BANK",
    "STATE BANK OF INDIA",
    "UNION BANK OF INDIA",
    "YES BANK LTD"
];

export default function CreditTxn() {
    const [userId, setUserId] = useState("");
    const [transactionAmount, setTransactionAmount] = useState("");
    const [balanceAmount, setBalanceAmount] = useState("");
    const [bankRRN, setBankRRN] = useState("");
    const [transactionType, setTransactionType] = useState("");
    const [type, setType] = useState("2");
    const [cardNumber, setCardNumber] = useState("");
    const [bankName, setBankName] = useState("");
    const [cardType, setCardType] = useState("");
    const [terminalId, setTerminalId] = useState("");
    const [fpTransactionId, setFpTransactionId] = useState("");
    const [transactionId, setTransactionId] = useState("");

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [modal, setModal] = useState({
        show: false,
        type: "success",
        title: "",
        message: ""
    });

    const validateForm = () => {
        const newErrors = {};
        if (!userId.trim()) newErrors.userId = "User ID is required";
        if (!transactionAmount || isNaN(transactionAmount) || Number(transactionAmount) <= 0) {
            newErrors.transactionAmount = "Enter a valid positive amount";
        }
        if (!bankRRN.trim()) newErrors.bankRRN = "Bank RRN is required";

        if (!cardNumber.trim()) {
            newErrors.cardNumber = "Card Number required";
        } else if (!/^\d{16}$/.test(cardNumber) && !/^\*{12}\d{4}$/.test(cardNumber)) {
            newErrors.cardNumber = "Enter valid card number (16 digits)";
        }

        if (!cardType) newErrors.cardType = "Selection of card is mandatory";
        if (!transactionType) newErrors.transactionType = "Selection of Transaction Type is mandatory";
        if (!bankName.trim()) newErrors.bankName = "Please select a bank";
        if (!terminalId.trim()) newErrors.terminalId = "Terminal ID is required";
        if (!transactionId.trim()) newErrors.transactionId = "Transaction ID is required";
        if (!fpTransactionId.trim()) newErrors.fpTransactionId = "Fingpay Transaction ID is required";
        if (balanceAmount === "" || isNaN(balanceAmount)) {
            newErrors.balanceAmount = "Balance Amount required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setUserId("");
        setTransactionAmount("");
        setBalanceAmount("");
        setBankRRN("");
        setTransactionType("");
        setCardNumber("");
        setCardType("");
        setBankName("");
        setTerminalId("");
        setFpTransactionId("");
        setTransactionId("");
        setErrors({});
    };

    const openModal = (config) => {
        setModal({ show: true, ...config });
    };

    const handleSubmit = async () => {
        if (loading) return;
        if (!validateForm()) return;
        setLoading(true);

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                userid: userId,
                transactionAmount: transactionAmount,
                balanceAmount: balanceAmount,
                bankRRN: bankRRN,
                transactionType: transactionType,
                type: type,
                cardNumber: cardNumber,
                bankName: bankName,
                cardType: cardType,
                terminalId: terminalId,
                fpTransactionId: fpTransactionId,
                transactionId: transactionId,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${BASE_URL_APISERVICES}${API_ENDPOINTS.TXN_CREDIT}`,
                requestOptions
            );

            const result = await response.json();


            if (result && result.status === "true") {
                openModal({
                    type: "success",
                    title: result.message || "Request Completed",
                    message: `RRN: ${result.bankRRN} - Transaction of ₹${result.transactionAmount} is successful.`
                });
                resetForm();
            } else {
                openModal({
                    type: "error",
                    title: "Failed",
                    message: result.message || "Transaction update failed."
                });
            }
        } catch (error) {
            openModal({
                type: "error",
                title: "Server Error",
                message: error.message || "Internal Server Error"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="a1b2c3_la-wrapper">
            <div className="a1b2c3_la-form-card">
                <div className="a1b2c3_la-form-container">
                    <div className="a1b2c3_la-header-section">
                        <h2 className="a1b2c3_la-form-title">Credit Transaction</h2>
                        </div>
                       

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">User ID</label>
                            <input
                                type="text"
                                value={userId}
                                onChange={(e) => { setUserId(e.target.value); setErrors({ ...errors, userId: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="Enter User ID"
                            />
                            {errors.userId && <span className="a1b2c3_la-error-text">{errors.userId}</span>}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Transaction ID</label>
                            <input
                                type="text"
                                value={transactionId}
                                onChange={(e) => { setTransactionId(e.target.value); setErrors({ ...errors, transactionId: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="Enter Transaction ID"
                            />
                            {errors.transactionId && <span className="a1b2c3_la-error-text">{errors.transactionId}</span>}
                        </div>
                    </div>


                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Fingpay Transaction ID</label>
                            <input
                                type="text"
                                value={fpTransactionId}
                                onChange={(e) => { setFpTransactionId(e.target.value); setErrors({ ...errors, fpTransactionId: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="Enter Fingpay Transaction ID"
                            />
                            {errors.fpTransactionId && <span className="la-error-text">{errors.fpTransactionId}</span>}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Bank RRN</label>
                            <input
                                type="text"
                                value={bankRRN}
                                onChange={(e) => { setBankRRN(e.target.value); setErrors({ ...errors, bankRRN: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="Enter Bank RRN"
                            />
                            {errors.bankRRN && <span className="a1b2c3_la-error-text">{errors.bankRRN}</span>}
                        </div>
                    </div>


                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Transaction Amount</label>
                            <input
                                type="number"
                                value={transactionAmount}
                                onChange={(e) => { setTransactionAmount(e.target.value); setErrors({ ...errors, transactionAmount: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="0.00"
                            />
                            {errors.transactionAmount && <span className="a1b2c3_la-error-text">{errors.transactionAmount}</span>}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Balance Amount</label>
                            <input
                                type="number"
                                value={balanceAmount}
                                onChange={(e) => { setBalanceAmount(e.target.value); setErrors({ ...errors, balanceAmount: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="0.00"
                            />
                            {errors.balanceAmount && <span className="a1b2c3_la-error-text">{errors.balanceAmount}</span>}
                        </div>
                    </div>


                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Type</label>
                            <input type="text" value={type} readOnly className="a1b2c3_la-input" />
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Card Number</label>
                            <input
                                type="text"
                                value={cardNumber}
                                onChange={(e) => { setCardNumber(e.target.value); setErrors({ ...errors, cardNumber: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="xxxxxxxx1234"
                                maxLength="16"
                            />
                            {errors.cardNumber && <span className="a1b2c3_la-error-text">{errors.cardNumber}</span>}
                        </div>
                    </div>


                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Bank Name</label>
                            <select
                                value={bankName}
                                onChange={(e) => {
                                    setBankName(e.target.value);
                                    setErrors({ ...errors, bankName: "" });
                                }}
                                className="a1b2c3_la-custom-select"
                            >
                                <option value="" disabled>Select Bank Name</option>
                                {bankList.map((bank, index) => (
                                    <option key={index} value={bank}>
                                        {bank}
                                    </option>
                                ))}
                            </select>
                            {errors.bankName && <span className="a1b2c3_la-error-text">{errors.bankName}</span>}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Card Type</label>
                            <select
                                value={cardType}
                                onChange={(e) => { setCardType(e.target.value); setErrors({ ...errors, cardType: "" }); }}
                                className="a1b2c3_la-custom-select"
                            >
                                <option value="" disabled>Select Card Type</option>
                                <option value="visa">Visa</option>
                                <option value="mastercard">Mastercard</option>
                                <option value="RuPay">Rupay</option>
                                <option value="maestro">Maestro</option>
                            </select>
                            {errors.cardType && <span className="a1b2c3_la-error-text">{errors.cardType}</span>}
                        </div>
                    </div>


                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Terminal ID</label>
                            <input
                                type="text"
                                value={terminalId}
                                onChange={(e) => { setTerminalId(e.target.value); setErrors({ ...errors, terminalId: "" }); }}
                                className="a1b2c3_la-input"
                                placeholder="Enter Terminal ID"
                            />
                            {errors.terminalId && <span className="a1b2c3_la-error-text">{errors.terminalId}</span>}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Transaction Type</label>
                            <select
                                value={transactionType}
                                onChange={(e) => { setTransactionType(e.target.value); setErrors({ ...errors, transactionType: "" }); }}
                                className="a1b2c3_la-custom-select"
                            >
                                <option value="" disabled>Select Transaction Type</option>
                                <option value="WDLS">Cash Withdrawal</option>
                                <option value="BE">Balance Enquiry</option>
                            </select>
                            {errors.transactionType && <span className="a1b2c3_la-error-text">{errors.transactionType}</span>}
                        </div>
                    </div>

                    <div className="a1b2c3_la-actions-row">
                        <button className="a1b2c3_la-submit-btn-half" onClick={handleSubmit} disabled={loading}>
                            {loading ? "Processing..." : 'Submit'}
                        </button>
                        <button className="a1b2c3_la-clear-btn-half" onClick={resetForm}>
                            Clear Form
                        </button>
                    </div>
                </div>
            </div>


            {modal.show && (
                <div className="fa-modal-overlay">
                    <div className="fa-modal-content" style={{ textAlign: 'center', padding: '2rem', background: '#fff', borderRadius: '8px' }}>
                        <div style={{
                            width: '70px', height: '70px', borderRadius: '50%',
                            backgroundColor: modal.type === "success" ? '#ecfdf5' : modal.type === "error" ? '#fff1f2' : '#fffbeb',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}>
                            {modal.type === "success" && <Check size={32} color="#10b981" strokeWidth={3} />}
                            {modal.type === "error" && <X size={32} color="#ef4444" strokeWidth={3} />}
                            {modal.type === "warning" && <Terminal size={32} color="#f59e0b" strokeWidth={3} />}
                        </div>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>{modal.title}</h3>
                        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '2rem' }}>{modal.message}</p>
                        <button
                            className="fa-btn"
                            style={{
                                background: modal.type === "success" ? '#10b981' : modal.type === 'error' ? '#ef4444' : '#f59e0b',
                                color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'
                            }}
                            onClick={() => setModal({ ...modal, show: false })}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

